import type { GameTheme } from "@skillscratch/shared-types";
import background from "./background.webp";
import name from "./name.webp";
import overlay from "./overlay.webp";

export const fortuneField = {
  id: "fortune-field",
  name: "Fortune Field",

  colorScheme: {
    tileColors: [
      { background: "#39ec8c", text: "#fff" },
      { background: "#39b54a", text: "#fff" },
      { background: "#21a34b", text: "#fff" },
      { background: "#015c2c", text: "#fff" },
    ],
    overlayPattern: overlay,
    overlayColor: "#01371A",
    scratchColor: "#015c2c",

    controlColor: "#015c2c",
    onControlColor: "#fff",
  },

  nameImage: name,
  background: background,
  card: background,

} satisfies GameTheme;
